import React from 'react';
import { REACT_APP_USER } from '@/utils/config';
import { AuthUser } from '@/model/AuthUser';
import { getBoolean, getItem } from '@/helpers/common/localStorage';

import avatar from '@/assets/images/avatar/avatar.svg';
import { path } from '@/navigation/path';

export const Header: React.FC = () => {
  const isUserStoraged = getBoolean(String(REACT_APP_USER));

  let user = {} as AuthUser;

  if (isUserStoraged) {
    user = getItem(String(REACT_APP_USER));
  }

  const titlePageHeader = [
    {
      route: path.Dashboard.Module.itself,
      title: 'Módulos',
      subTitle: 'Parâmetros / Módulos',
    },
    {
      route: path.Dashboard.Permission.itself,
      title: 'Permissões',
      subTitle: 'Parâmetros / Permissões',
    },
    {
      route: path.Dashboard.Menu.itself,
      title: 'Menu',
      subTitle: 'Parâmetros / Menu',
    },
    {
      route: path.Dashboard.SubMenu.itself,
      title: 'Sub Menu',
      subTitle: 'Parâmetros / Sub Menu',
    },
    {
      route: path.Dashboard.CardFee.itself,
      title: 'Taxas',
      subTitle: 'Parâmetros / Taxas',
    },
    {
      route: path.Dashboard.AcquiringFee.itself,
      title: 'Adquirentes',
      subTitle: 'Parâmetros / Adquirentes',
    },
    {
      route: path.Dashboard.GatewayPriority.itself,
      title: 'Prioridades Gateway',
      subTitle: 'Parâmetros / Gateway',
    },
    {
      route: path.Dashboard.ProducerFee.itself,
      title: 'Produtor',
      subTitle: 'Parâmetros / Produtor',
    },
    {
      route: path.Dashboard.Email.itself,
      title: 'Emails',
      subTitle: 'Parâmetros / Emails',
    },
    {
      route: path.Dashboard.itself,
      title: 'Dashboard',
      subTitle: 'Dashboard',
    },
    {
      route: path.Dashboard.Events.itself,
      title: 'Eventos Ativos',
      subTitle: 'Eventos / Ativos',
    },
    {
      route: path.Dashboard.FinishedEvents.itself,
      title: 'Eventos Finalizados',
      subTitle: 'Eventos / Finalizados',
    },
    {
      route: path.Dashboard.FinishedEventDetail.itself,
      title: 'Eventos Finalizados',
      subTitle: 'Eventos / Finalizados',
    },
    {
      route: path.Dashboard.ReleaseEvent.itself,
      title: 'Aguardando Liberação',
      subTitle: 'Eventos / Aguardando Liberação',
    },
    {
      route: path.Dashboard.Event.itself,
      title: 'Evento',
      subTitle: 'Dashboard / Eventos',
    },
    {
      route: path.Dashboard.Event.edit,
      title: 'Evento',
      subTitle: 'Dashboard / Eventos',
    },
    {
      route: path.Dashboard.EventClose.itself,
      title: 'Fechamento de evento',
      subTitle: 'Evento / Fechamento de evento',
    },
    {
      route: path.Dashboard.User.itself,
      title: 'Usuários e Perfis',
      subTitle: 'Administração / Usuários e Perfis',
    },
    {
      route: path.Dashboard.Clients.itself,
      title: 'Gestão de clientes',
      subTitle: 'Administração / Gestão de clientes',
    },
    {
      route: path.Dashboard.Pdv.itself,
      title: 'PDV',
      subTitle: 'Administração / PDV',
    },
    {
      route: path.Dashboard.Pos.itself,
      title: 'POS',
      subTitle: 'Administração / POS',
    },
    {
      route: path.Dashboard.ProductsCombos.itself,
      title: 'Produtos e Combos',
      subTitle: 'Administração / Produtos e Combos',
    },
    {
      route: path.Dashboard.Product.itself,
      title: 'Produtos',
      subTitle: 'Administração / Produtos e Combos / Produtos',
    },
    {
      route: path.Dashboard.Combo.itself,
      title: 'Combos',
      subTitle: 'Administração / Produtos e Combos / Combos',
    },
    {
      route: path.Dashboard.GroupSubgroupProduct.itself,
      title: 'Grupos e Subgrupos de produtos',
      subTitle: 'Administração / Produtos e Combos / Grupos e Subgrupos de produtos',
    },
    {
      route: path.Dashboard.Company.itself,
      title: 'Contratantes',
      subTitle: 'Administração / Contratantes',
    },
    {
      route: path.Dashboard.Gateway.itself,
      title: 'Gateway de pagamento',
      subTitle: 'Administração / Gateway de pagamento',
    },
    {
      route: path.Dashboard.Payment.itself,
      title: 'Formas de pagamento',
      subTitle: 'Administração / Formas de pagamento',
    },
    {
      route: path.Dashboard.Document.itself,
      title: 'Documentos',
      subTitle: 'Administração / Documentos',
    },
    {
      route: path.Dashboard.Log.itself,
      title: 'Logs',
      subTitle: 'Administração / Logs',
    },
    {
      route: path.Dashboard.Event.itself,
      title: 'Cadastrar evento',
      subTitle: 'Eventos / Cadastrar evento',
    },
    {
      route: path.Dashboard.Event.edit,
      title: 'Cadastrar evento',
      subTitle: 'Eventos / Editar evento',
    },
    {
      route: path.Dashboard.Bracelet.itself,
      title: 'Pulseiras',
      subTitle: 'Eventos / Cadastrar pulseiras',
    },
    {
      route: path.Dashboard.CreateSaleRequest.itself,
      title: 'Vendas',
      subTitle: 'Vendas / Criar venda',
    },
    {
      route: path.Dashboard.Redemption.itself,
      title: 'Solic. Resgates',
      subTitle: 'Financeiro / Solic. Resgates',
    },
    {
      route: path.Dashboard.RedemptionFinished.itself,
      title: 'Resgates Realiz.',
      subTitle: 'Financeiro / Resgates Realiz.',
    },
    {
      route: path.Dashboard.Support.itself,
      title: 'Atendimento',
      subTitle: 'Suporte / Atendimento',
    },
    {
      route: path.Dashboard.CancelAdmTicketsRoutes.eventCancelTicket,
      title: 'Cancelar Pedido ADM',
      subTitle: 'Suporte / Cancelar Pedido ADM',
    },
    {
      route: path.Dashboard.ProducerProduct.itself,
      title: 'Produtos do Produtor',
      subTitle: 'Produtor / Produtos',
    },
    {
      route: path.Dashboard.Chargeback.itself,
      title: 'Chargeback',
      subTitle: 'Suporte / Chargeback',
    },
    {
      route: path.Dashboard.Financial.itself,
      title: 'Financeiro',
      subTitle: 'Financeiro',
    },
    {
      route: path.Dashboard.Statement.itself,
      title: 'Financeiro',
      subTitle: 'Financeiro / Extrato',
    },
    {
      route: path.Dashboard.GatewayPayment.itself,
      title: 'Financeiro',
      subTitle: 'Financeiro / Gateway',
    },
    {
      route: path.Dashboard.EventCloseCsv.itself,
      title: 'Financeiro',
      subTitle: 'Financeiro / Consolidação de vendas',
    },
  ];

  return (
    <div className="page-header">
      <div className="path-container">
        <div className="path-flex-container">
          <span className="path-path">
            {titlePageHeader.filter(item => item.route === window.location.pathname)[0]?.subTitle ??
              ''}
          </span>
          <span className="path-main">
            {titlePageHeader.filter(item => item.route === window.location.pathname)[0]?.title ??
              ''}
          </span>
        </div>
      </div>

      <div className="nav-right col-8 pull-right right-header p-0">
        <ul className="nav-menus">
          <li className="">
            <div className="media profile-media" title={user?.name}>
              <img className="user-img" src={user?.imageUrl ? user?.imageUrl : avatar} alt="" />
              <div className="media-body profile-name">
                <span>{user?.name}</span>
                <div className="profile-user">
                  {user?.profile} <i className=""></i>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
};
